import { AppUser, ImmigrationProfile } from "src/app/core/api.gen";
import { isNullOrUndefined } from "../../../../app/core/utils";

export function checkAcess(
    model: ImmigrationProfile,
    activeUser: AppUser,
    isVisaApprover: boolean,
    country: string) {

    if (isVisaApprover) {
        if (country == 'BT')
        {
            return true;
        }
        let noOfficeTobeVisited = model.officeToBeVisited && model.officeToBeVisited.id && !activeUser.userOfficeLocation.includes(model.officeToBeVisited.id);
        let noOfficeLoc = model.officeLocation && model.officeLocation.id && !activeUser.userOfficeLocation.includes(model.officeLocation.id);
        let noOfficeLE = model.officeLE && model.officeLE.id && !activeUser.userOfficeLegalEntities.includes(model.officeLE.id);
        let ifKSA = country == 'SAU';

        let isOfficeSame = !isNullOrUndefined(model.officeToBeVisited && model.officeToBeVisited.id) ? noOfficeTobeVisited : noOfficeLoc

        if (!ifKSA && isOfficeSame) {
            return false;
        }

        if (ifKSA && noOfficeLE) {
            return false;
        }

        return true;
    }
    // Checking if the createdbyId is same as current user OR
    // Created team is any one in roleids of the current user
    // 
    //checks if user is onBehalfRequestor

    if ((model.immEmployee && model.immEmployee.id !== null && activeUser.email !== model.immEmployee.userPrincipalName))
    {
       if((model.onBehalfRequestor && model.onBehalfRequestor.id !== null && activeUser.email !== model.onBehalfRequestor.userPrincipalName))
       {
        if (
          (!activeUser.roleIds.includes(model.createdByRoleId) && model.createdByRoleId !== 6) ||
          (model.createdBy !== activeUser.employeeId && model.createdByRoleId === 6)) 
          {
          return false;
          }
        }
    }

    return true;
}
